import * as safeAreaInsets from "safe-area-insets";
var canvas = document.createElement("canvas");
var context = canvas.getContext("2d");
export function measureText(text, font) {
    if (font === void 0) { font = ""; }
    context.font = font;
    return context.measureText(text);
}
/**
 * 滚动到顶部
 */
export function scrollTop(wrapper) {
    if (wrapper) {
        wrapper.scrollTo({
            top: 0,
            left: 0,
        });
    }
    else {
        if (document.documentElement.scrollTop) {
            document.documentElement.scrollTo({
                behavior: "smooth",
                top: 0,
            });
        }
        if (document.body.scrollTop) {
            document.body.scrollTo({
                behavior: "smooth",
                top: 0,
            });
        }
    }
}
export function transformStyle(styles) {
    return Object.keys(styles)
        .map(function (name) { return name + ":" + styles[name]; })
        .join(";");
}
/**
 * 此方法需要依赖vant的loading组件
 * 或者手动引入下面两个动画
 *
  @keyframes van-rotate {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }
 *
 @keyframes van-circular {
    0% {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0;
    }

    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -40;
    }

    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -120;
    }
  }
 *
 */
export function showLoading(styles) {
    if (styles === void 0) { styles = {}; }
    if (document.getElementById("sui-loading")) {
        return;
    }
    var defaultStyle = {
        position: "fixed",
        width: "3rem",
        height: "3rem",
        background: "rgba(0,0,0,0.7)",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        color: "#fff",
        "z-index": 10000,
        "border-radius": "0.2rem",
        opacity: 0,
        transition: "opacity 0.5s",
    };
    var div = document.createElement("div");
    div.id = "sui-loading";
    div.setAttribute("style", transformStyle(Object.assign({}, defaultStyle, styles)));
    div.innerHTML = "\n    <svg \n      viewBox=\"25 25 50 50\" \n      style=\"\n        display:block;\n        width:50%;\n        height:50%;\n        -webkit-animation: van-rotate 1.2s linear infinite;\n        animation: van-rotate 1.2s linear infinite;\n        margin:25% 0 0 25%;\"\n    >\n      <circle \n        cx=\"50\" \n        cy=\"50\" \n        r=\"20\" \n        fill=\"none\" \n        style=\"\n          -webkit-animation: van-circular 2s ease-in-out infinite;\n          animation: van-circular 2s ease-in-out infinite;\n          stroke: currentColor;\n          stroke-width: 2;\n          stroke-linecap: round;\">\n      </circle>\n    </svg>\n  ";
    document.body.appendChild(div);
    setTimeout(function () {
        div.style.opacity = "1";
    }, 0);
}
export function hideLoading() {
    var div = document.getElementById("sui-loading");
    var timer = 0;
    if (div) {
        div.addEventListener("transitionend", function (e) {
            div.remove();
            clearTimeout(timer);
        }, false);
        div.style.opacity = "0";
        timer = setTimeout(function () {
            try {
                div.remove();
            }
            catch (error) { }
        }, 500);
    }
}
export function fix100vh() {
    if (document.body.classList.contains("fix-100vh")) {
        return;
    }
    function getDocHeight() {
        return document.documentElement.clientHeight || document.body.clientHeight;
    }
    function addCssParamOf100vh() {
        var height = Math.max(window.innerHeight, getDocHeight());
        if (safeAreaInsets.support) {
            height = height - safeAreaInsets.top - safeAreaInsets.bottom;
        }
        document.body.style.setProperty("--vh100", height + "px");
    }
    window.addEventListener("resize", addCssParamOf100vh);
    safeAreaInsets.onChange(addCssParamOf100vh);
    document.body.classList.add("fix-100vh");
    addCssParamOf100vh();
}
